<template>
  <div class="change-password-block">
    <v-layout pa-2 mt-2>
      <v-flex>
        <v-card>
          <v-card-title>
            <div>
              <div class="headline">
                שינוי סיסמא:
              </div>
            </div>
          </v-card-title>
            <v-layout row wrap >
              <v-flex xs12 sm12 md12 lg8 pa-2 mb-2 >
                <v-form ref="change_password" data-vv-scope="change_password" lazy-validation>
                  <v-layout row wrap px-2>
                    <v-flex xs12>
                      <v-text-field
                        label="סיסמא ישנה"
                        :type="showOldPassword ? 'text' : 'password'"
                        v-model="form.oldPassword"
                        v-validate="'required|min:6'"
                        data-vv-name="change_password.oldPassword"
                        :error-messages="errors.collect('change_password.oldPassword')"
                        v-on:keyup.enter="changePassword()"
                        required
                        height="32"
                        :append-icon="showOldPassword ? 'visibility' : 'visibility_off'"
                        @click:append="showOldPassword = !showOldPassword"
                        single-line
                        solo
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        label="סיסמא חדשה "
                        ref="newPassword"
                        name="newPassword"
                        :type="showNewPassword ? 'text' : 'password'"
                        v-model="form.newPassword"
                        v-validate="'required|min:6'"
                        data-vv-name="change_password.newPassword"
                        :error-messages="errors.collect('change_password.newPassword')"
                        v-on:keyup.enter="changePassword()"
                        required
                        height="32"
                        :append-icon="showNewPassword ? 'visibility' : 'visibility_off'"
                        @click:append="showNewPassword = !showNewPassword"
                        single-line
                        solo
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        label="הקלד מחדש סיסמא חדשה"
                        v-model="form.retypeNewPassword"
                        :type="showNewRetypePassword ? 'text' : 'password'"
                        v-validate="'required|confirmed:newPassword'"
                        data-vv-name="change_password.confirmed"
                        data-vv-as="newPassword"
                        :error-messages="errors.collect('change_password.confirmed')"
                        v-on:keyup.enter="changePassword()"
                        required
                        height="32"
                        :append-icon="showNewRetypePassword ? 'visibility' : 'visibility_off'"
                        @click:append="showNewRetypePassword = !showNewRetypePassword"
                        single-line
                        solo
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-form>
                <v-btn color="primary" class="submit"
                  @click="changePassword()"
                  :loading="loading"
                  :disabled="loading"
                >שנה סיסמא</v-btn>
              </v-flex>
            </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'ChangePasswordBlock',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      loading: false,
      showOldPassword: false,
      showNewPassword: false,
      showNewRetypePassword: false,
      form: {
        oldPassword: '',
        newPassword: '',
        retypeNewPassword: ''
      },
      dictionary: {
        en: {
          custom: {
            'change_password.newPassword': {
              required: 'New password required',
              min: 'Required at least 6 symbols'
            },
            'change_password.confirmed': {
              required: 'Retype new password required',
              confirmed: 'New password doesn\'t match'
            },
            'change_password.oldPassword': {
              required: 'Old password required',
              min: 'Required at least 6 symbols'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
  },
  methods: {
    changePassword () {
      this.$validator.validateAll('change_password').then(res => {
        if (res) {
          this.loading = true
          this.$store.dispatch('CHANGE_USER_PASSWORD', { oldPassword: this.form.oldPassword, newPassword: this.form.newPassword }).then(res => {
            this.loading = false
            this.$toasted.show('Password was successfully changed')
            this.clearForm()
          }, err => {
            this.loading = false
            console.log('CHANGE_USER_PASSWORD error', err)
            let errorText = this.$services.getApiError(err)
            if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
          })
        }
      })
    },
    clearForm () {
      this.form = {oldPassword: '', newPassword: '', retypeNewPassword: ''}
      setTimeout(() => {
        this.$validator.errors.clear('change_password')
        this.$refs.change_password.resetValidation()
      }, 50)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/ChangePasswordBlock.vue